import { render, staticRenderFns } from "./cms-section-item-list.vue?vue&type=template&id=245809a9&"
import script from "./cms-section-item-list.vue?vue&type=script&lang=js&"
export * from "./cms-section-item-list.vue?vue&type=script&lang=js&"
import style0 from "./_cms-section-item-list.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports